import ReactGA from 'react-ga4'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import { store } from 'libraries/redux'
import { PageLayout } from 'components'
import { ThemeContextProvider } from 'context'
import ToastServices from 'libraries/toastify/toastServices'

import './styles/index.global.scss'
import FacebookMetaTag from 'shared/ui/FacebookMetaTag'
import SupplierProvider from 'context/SupplierContext'
import { CartDrawerProvider } from 'context/BasketDriverContext/BasketDriverContext'
import { CartDrawer } from './entities/Basket'
import { WishlistDrawerProvider } from 'context/WishlistDrawerContext/WishlistDrawerContext'
import { WishlistSidebar } from './entities/Favorites/ui/WishlistSidebar'
import { BurgerMenuProvider } from 'context/BurgerMenuContext/BurgerMenuContext'
import AppInitializer from 'shared/lib/utils/AppInitializer'

ReactGA.initialize('G-JRC0NEEBB3')

const App = () => (
  <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
    <Provider store={store}>
      <BurgerMenuProvider>
        <CartDrawerProvider>
          <WishlistDrawerProvider>
            <ThemeContextProvider>
              <SupplierProvider>
                <FacebookMetaTag />
                <AppInitializer />
                <PageLayout />
                <CartDrawer />
                <WishlistSidebar />
              </SupplierProvider>
              <ToastServices />
            </ThemeContextProvider>
          </WishlistDrawerProvider>
        </CartDrawerProvider>
      </BurgerMenuProvider>
    </Provider>
  </BrowserRouter>
)

export default App
